<template>
  <div>
    <div class="zw_display">
      <div class="tabcontent clearfix" style="display: block">
        <div class="position">
          <div class="photo">
            <img src="@/assets/images/joinus/kftp1.png" />
          </div>
          <div class="detail">
            <h5>软件架构师/软件开发经理 （1名）</h5>
            <h6 class="nbot">工作地点：武汉</h6>
            <ul class="skills">
              <li>学历要求：211高校计算机、模式识别、智能与自动化专业硕士学位;</li>
              <li>工作年限：5年及以上。</li>
            </ul>
            <h6 class="nbot">职位描述及任职要求：</h6>
            <div class="skills">
              <li>1.作为技术骨干或项目负责人，带领团队主持负责过大型软件开发；</li>
              <li>2.有机器学习与大数据方向的软件开发经验；在初创公司担任过技术负责人或在大型IT公司担任过技术骨干;</li>
              <li>3.精通C++/Python/Java;</li>
              <li>
                特质描述：
                <ul class="padding">
                  <li>1）愿意接受挑战，目标感强，具有成就欲望；责任感强，有担当，并且具有较强的表达与沟通能力；</li>
                  <li>2）极强的逻辑思维能力和解决问题的能力，软件工程能力突出；</li>
                  <li>3）学习能力强，能在迅速消化新领域的已有技术基础上做技术创新或迭代。</li>
                </ul>
              </li>
            </div>
          </div>
        </div>

        <div class="position">
          <div class="photo">
            <img src="@/assets/images/joinus/kftp2.png" />
          </div>
          <div class="detail">
            <h5>软件开发工程师/C++开发工程师 （2名）</h5>
            <h6>工作地点：武汉、上海</h6>
            <h6 class="nbot">任职资格</h6>
            <div class="skills">
              <li>1.计算机、电子、通信及自动化专业本科学历；</li>
              <li>2.c++基础能力扎实，深刻理解面向对象，封装等；</li>
              <li>3.熟练掌握linux下各种常用操作命令，会GDB调试；</li>
              <li>4.了解linux/windows系统各种文件操作编程；</li>
              <li>5.对常用的数据结构能熟练掌握，并知道其原理；</li>
              <li>6.正直诚信，沉稳自信，有强烈的进取精神和求知欲，对新技术充满热情；</li>
              <li>7.工作细致认真，有责任心，具备良好的团队合作精神和沟通能力。</li>
            </div>
          </div>
        </div>

        <div class="position">
          <div class="photo">
            <img src="@/assets/images/joinus/kftp3.png" />
          </div>
          <div class="detail">
            <h5>嵌入式系统开发工程师（1名)</h5>
            <h6>工作地点：武汉</h6>
            <h6 class="nbot">职位描述：</h6>
            <ul class="skills">
              <li>1.负责高端拾音器、声纹识别模组、降噪模组等硬件产品开发；</li>
              <li>2.负责硬件外包技术沟通和质量把控。</li>
            </ul>
            <h6 class="nbot">任职资格</h6>
            <ul class="skills">
              <li>1.电子或通信类专业本科以上学历，具有实际嵌入系统产品5年以上开发经验；</li>
              <li>2.能够熟练地使用ARM 和DSP 进行算法开发；</li>
              <li>3.精通C 和C++，有良好的汇编基础，能够使用C 和汇编混合编程；</li>
              <li>4.能够熟练运用Matlab 进行数学建模和算法验证；</li>
              <li>5.熟悉Linux 驱动模型，能够熟练开发Linux 内核驱动；</li>
              <li>6.熟悉Android 系统架构，能够进行Linux 子系统、hal 层以及Framework 层开发；</li>
              <li>7.对于数字滤波器设计、FFT 变换及其逆变换、并行计算、人工神经网络加速有丰富开发经验者优先；</li>
              <li>8.英语要求有较强的阅读能力，可进行各种电子器件Datasheet的阅读;</li>
              <li>9.对相关的硬件和外购元器件合格供应商、硬件设计外包商具有较好的确认能力;</li>
              <li>10.具备良好沟通，协调及团队合作能力；具备良好的学习能力、具有强烈的进取心、愿意接受挑战；为人诚恳、乐观、做事踏实守信。</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 研发质量管理 2 -->
      <!-- <div class="tabcontent clearfix">
            <div class="position">
                <div class="photo">
                    <img src="../../../assets/images/joinus/cstp1.png"/>
                </div>
                <div class="detail">
                    <h5>测试工程师（测试经理1名优先招募，测试工程师2名）</h5>
                    <h6>工作地点：武汉</h6>
                    <h6 class="nbot">职位描述：</h6>
                    <ul class="skills">
                        <li>1.根据产品需求及设计文档编写软件测试用例，每个测试用例流程清晰，目标明确；</li>
                        <li>2.把控软件质量，推动开发工程师解决BUG，确保软件按时发布；</li>
                        <li>3.及时反映产品缺陷，并配合研发人员定位问题；</li>
                        <li>4.对产品质量进行评估，协助技术总监、产品经理发布版本。</li>
                    </ul>
                    <h6 class="nbot">任职要求：</h6>
                    <ul class="skills">
                        <li> 1. 211高校计算机、自动化等相关专业本科及以上学历；</li>
                        <li>2. 责任心强，工作认真负责，有良好的语言表达和沟通能力； </li>
                        <li>3. 具有逆向思维能力和缜密的逻辑推理能力，具有很强的文档编写能力，思路清晰，重点突出； </li>
                        <li>4. 3年及以上测试工作经验，能够熟练应用多种测试工具；</li>
                        <li>5. 熟悉软件开发流程、软件测试流程，了解黑盒、白盒测试； </li>
                        <li>6. 熟悉使用shell、Python、Golang、C#一种或多种脚本语言编程自动化测试工具者优先；</li>
                        <li>7. 有语音识别、人脸识别等产品测试经验者优先。</li>
                    </ul>
                </div>
            </div>

            <div class="position">
                <div class="photo">
                    <img src="../../../assets/images/joinus/cstp2.png"/>
                </div>
                <div class="detail">
                    <h5>产品助理（1名）</h5>
                    <h6>工作地点：武汉</h6>
                    <h6 class="nbot">职位描述：</h6>
                    <ul class="skills">
                        <li>1.按照公司文档开发规范进行产品的用户文档编写工作并完成日常维护;</li>
                        <li>2. 调研用户需求，收集用户数据，对用户行为进行分析和研究。制定用户文档的开发计划，并控制计划的执行;</li>
                        <li>3.针对设计的HMM、GMM等语音模型，研究如何降低模型参数的规模以提高系统的训练速度，减小模型规模；</li>
                        <li>4. 集中存储所有文档资料，保证文档版本与代码版本的一致性，维护文档资料的索引表，定期备份文档资料;</li>
                        <li>5. 参与文档的标准化、制度化规范化等工作;</li>
                        <li>6. 参与联机文档编译和测试，相关的技术支持工作;</li>
                        <li>7. 编写产品指标说明书、使用手册，制作演示幻灯片，公司网站维护等。</li>
                    </ul>
                    <h6 class="nbot">任职要求：</h6>
                    <ul class="skills">
                        <li>1.本科及以上学历，通信、计算机、电子、无线电、自动控制等专业；</li>
                        <li>2.具有产品开发和文档编写及绘图软件使用的经验，能熟练运用各种办公软件，且尽可能学会使用Rose、ReqPro、SoDA等软件工程方面的软件；</li>
                        <li>3.跟进产品的整个设计研发进程，推动、控制、协调产品的研发与发布；</li>
                        <li>4.处理部门间沟通与协调，推动和配合公司对产品的运营及发展；</li>
                        <li>5.具备PRD需求文档撰写、产品原型设计能力、基础交互能力、技术理解能力；</li>
                        <li>6. 具备良好的逻辑思维能力，思路清晰，能够清楚、简明地陈述问题；</li>
                        <li>7. 具备较强的文字处理能力，擅长总结和归纳；</li>
                        <li>8.工作细致耐心，有一定的抗压能力及团队合作精神，较强的责任感及进取精神。</li>
                    </ul>
                </div>
            </div>
      </div>-->

      <!-- 算法 -->
      <!-- <div class="tabcontent clearfix">
          <div class="position">
            <div class="photo">
              <img src="../../../assets/images/joinus/sftp1.png" />
            </div>
            <div class="detail">
              <h5>算法工程师 （1-2名）</h5>
              <h6>工作地点：武汉</h6>
              <h6 class="nbot">职位描述：</h6>
              <ul class="skills">
                <li>1.语音降噪算法开发方向： 在已有的抑噪和语音增强算法基础上优化设计适用于各种场景下的语音信号采样和降噪算法，为语音识别提供高质量的音频信号；</li>
                <li>2.语音算法开发方向：在已有的近二十种语音模型算法基础上针对特定场景进行算法优化开发，支撑产品开发工程师进行场景化产品开发；</li>
                <li>
                  3.机器学习算法开发方向：针对样本数据和语音模型，优化训练算法以提高模型训练速度和拟合精度，获得全局最优的模型参数；设计不同于传统的语音分类方法，研究如何利用神经网络进行语音识别和
                  语义理解，并进行工程应用开发。
                </li>
              </ul>
              <h6 class="nbot">任职要求：</h6>
              <ul class="skills">
                <li>1.计算机科学、模式识别、控制理论与控制工程相关专业硕士毕业生，具有3年以上工作经验；</li>
                <li>2.掌握多元统计分析、数据挖掘、机器学习、神经网络理论；</li>
                <li>3.熟练掌握Python和C++程序语言；</li>
                <li>4.有较强的算法基础和工程实际经验；</li>
                <li>5.善于思考，具有独立解决问题的能力；</li>
                <li>6.工作踏实上进，具有良好的团队合作精神。</li>
              </ul>
            </div>
          </div>

          <div class="position">
            <div class="photo">
              <img src="../../../assets/images/joinus/sftp3.png" />
            </div>
            <div class="detail">
              <h5>算法研究员 （1-2名）</h5>
              <h6>工作地点：武汉</h6>
              <h6 class="nbot">职位描述：</h6>
              <ul class="skills">
                <li>1.模式识别与自然语言处理方向：在本公司已有的语音、图像识别和自然语言处理算法研发成果基础上，承担公司面向国防与公共安全领域情绪识别、多模态识别、语音交互、声学探测等领域的创新研发项目；</li>
                <li>2.机器学习/数据挖掘/优化算法方向：针对特定应用场景的机器学习算法优化，大数据算法开发。</li>
              </ul>
              <h6 class="nbot">任职要求：</h6>
              <ul class="skills">
                <li>1.学历要求：211高校计算机科学、模式识别、控制理论与控制工程专业博士学位；</li>
                <li>2. 工作年限：应届毕业生或者往届均可，有工作经验者优先；</li>
                <li>3. 精通多元统计分析、数据挖掘、机器学习、神经网络理论；</li>
                <li>
                  4. 研究及项目经历：有以下软件算法研究经历（五项必有其一）
                  <ul class="padding">
                    <li>1）模式识别（语音或图像识别）；</li>
                    <li>2）自然语言处理（NLP）；</li>
                    <li>3）机器学习或大数据挖掘；</li>
                    <li>4）优化算法设计及工程应用；</li>
                    <li>5）神经网络深度学习；</li>
                  </ul>
                </li>
                <li>5.工作踏实上进，具有良好的团队合作精神。</li>
              </ul>
            </div>
          </div>
      </div>-->
    </div>
    <div class="tips">
      <h5>招聘流程和联系方式</h5>
      <h6>招聘流程</h6>
      <p>简历投递--电话面试--现场初试--现场复试--录用</p>
      <h6>联系方式</h6>
      <ul class="skills">
        <li>联系电话：027-81736698、13995546358</li>
        <li>简历投递邮箱：hr@dasoundgen.com</li>
        <li>地址：中国•光谷•武大科技园航域二区B3栋7楼</li>
      </ul>
    </div>

    <div class="tips">
      <h5 class="treatment">福利待遇</h5>
      <p>
        应聘者一经录用，入职当天即签订正式劳动合同（实习生签订实习协议，应届生签订三方协议），将享受包括基本工资、绩效奖金、年终奖金、五险一
        金、项目奖金、其他津（补）贴、带薪休假、在职培训、传统节日及生日礼品、年度体检等在内富有市场竞争力的薪酬福利待遇。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style scoped>
.tabcontent {
  width: 62.5%;
  display: block;
}
.tips {
  padding: 30px 0;
  width: 779px;
  border-bottom: 1px solid rgba(243, 243, 243, 1);
}
.tabcontent {
  width: 779px;
  display: block;
}
.tab {
  width: 779px;
}
.nbot {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/aboutus/joinus/develop.vue